import { ValidatorFn } from '@angular/forms';
import { ConditionPropertyOperator, PropertyFilter } from '@models/index';

export interface FilterCriterion {
  key: string;
  label: string;
  placeholder: string;
  field: string;
  type: FieldType;
  outputDateFormat?: OutputDateFormat;
  filter?: boolean;
  operation: ConditionPropertyOperator;
  options?: FilterDropdownOption[];
  access?: AccessFilterItem[];
  maxLength?: number;
  validators?: ValidatorFn[];
  dateOptions?: DateOptions;
}

export interface DateOptions {
  minDateField?: string;
  maxDateField?: string;
  dateFormat?: string;
  timeFormat?: string;
}

export interface AccessFilterItem {
  hideFor?: number[];
  showFor?: number[];
  fieldName: string;
}

export enum OutputDateFormat {
  DateOnly = 'dateOnly',
  DateTime = 'dateTime',
}

export enum FieldType {
  Text = 'text',
  Date = 'date',
  Select = 'select',
  MultipleSelect = 'multipleSelect',
}

export interface FilterModalData {
  filterCriteria: FilterCriterion[];
  selectedValues?: {
    propertyName?: string;
    key: string;
    values?: string[];
    value?: string;
    entityPropertyFilters?: PropertyFilter[];
  }[];
}

export interface FilterModalResult {
  key: string;
  values: string[];
  operation: ConditionPropertyOperator;
  field?: string;
  type?: string;
}

export interface FilterDropdownOption {
  id: number;
  displayName: string;
  value: string;
  key?: string;
}
